export type Pillar = {
  readonly id: string;
  readonly title: string;
  readonly body: string;
};

export const EXISTING_ASSETS_LABEL = "Existing assets";

export const EXISTING_ASSETS: readonly string[] = [
  "Yarn portfolio",
  "Structure library",
  "CAD programs",
  "Knitting machines",
  "Testing data",
  "Manufacturing knowledge",
  "Designers",
];

export const PILLARS_LABEL = "New possibilities";

export const PILLARS: readonly Pillar[] = [
  {
    id: "faster",
    title: "Faster",
    body: "Development measured in weeks, not seasons. Fewer rounds of physical sampling, room for one-off trials, and time to make trends instead of chasing them.",
  },
  {
    id: "smarter",
    title: "Smarter",
    body: "The knit expertise is baked into the software. Designers can access that expertise earlier, while knit engineers focus on the decisions where their experience matters most.",
  },
  {
    id: "connected",
    title: "Connected",
    body: "Designers, knit engineers, and product teams work from one connected file, carrying design intent forward without handoffs.",
  },
];
